import type { AppSessionResponse, AppSessionUser } from './app-session.types'

export const APP_SESSION_QUERY_KEY = ['app-session'] as const

const APP_SESSION_ENDPOINT = '/api/auth/session/'
const ACCESS_MARKER_COOKIE = 'Authentication__e'
const REFRESH_MARKER_COOKIE = 'Refresh__e'

class AppSessionRequestError extends Error {
  constructor(readonly status: number) {
    super(`App session request failed with status ${status}`)
    this.name = 'AppSessionRequestError'
  }
}

export async function fetchAppSession(): Promise<AppSessionUser | null> {
  const response = await fetch(APP_SESSION_ENDPOINT, {
    credentials: 'include',
    cache: 'no-store',
  })

  if (!response.ok) {
    throw new AppSessionRequestError(response.status)
  }

  // oxlint-disable-next-line typescript/no-unsafe-type-assertion -- response.json() is untyped
  const data = (await response.json()) as AppSessionResponse
  return data.session
}

export function accessMarkerCookieExists() {
  return markerCookieExists(ACCESS_MARKER_COOKIE)
}

export function refreshMarkerCookieExists() {
  return markerCookieExists(REFRESH_MARKER_COOKIE)
}

export function shouldSkipAuthPreflight(query: string) {
  return query.includes('mutation signInRefresh') || query.includes('mutation signOut')
}

function markerCookieExists(name: string) {
  if (typeof document === 'undefined') {
    return false
  }

  return document.cookie.split(';').some(cookie => cookie.trim().startsWith(`${name}=`))
}
